import { toMoment } from 'api/helpers';
import OrderType from './OrderType';
import he from 'he';

export default class PackItem {
	id = null;
	name = '';
	db_item_name = '';
	number = '';
	base_number = '';
	quantity_in_pack = 0;
	quantity = 0;
	list_price = 0;
	ta = 0;
	net_price = 0;
	est_ship_date = null;
	invoice_hold_weeks = 0;
	image_url = null;
	order_type = null;
	promo_price = 0;
	currency_symbol = '';
	country_short_name = '';
	is_configurable = false;
	is_preview = false;
	total_config_qty_ordered = 0;
	est_ship_date_for_cart = null;
	quantity_available = 0;
	category_promotion_class_id = 0;
	promo_no_of_days = null;
	pack_name = null;
	price_list = null;
	item_description = '';
	category_ship_type_id = 0;
	category_ship_type_name = '';

	constructor(product) {
		this.id = product.Id;
		this.name = he.decode(product.Name);
		this.db_item_name = product.Name;
		this.number = product.Number;
		this.base_number = product.BaseNumber;
		this.quantity_in_pack = product.QuantityInPack;
		this.quantity = product.Quantity;
		this.list_price = product.ListPrice;
		this.promo_price = product.PromoPrice;
		this.ta = product.TA;
		this.net_price = product.NetPrice;
		this.est_ship_date = toMoment(product.EstShipDate);
		this.invoice_hold_weeks = product.OrderType.HoldInvoiceWeeks;
		this.order_type = new OrderType(product.OrderType);
		this.image_url = product.ImageUrl;
		this.currency = {
			currency_symbol: product.CurrencySymbol,
			country_short_name: product.CountryShortName,
		};
		this.is_configurable = product.IsConfigurable;
		this.is_preview = product.IsPreview;
		this.total_config_qty_ordered = product.TotalConfigQtyOrdered;
		this.est_ship_date_for_cart = toMoment(product.EstShipDateForCart);
		this.quantity_available = product.QuantityAvailable;
		this.category_promotion_class_id = product.CategoryPromotionClassId;
		this.promo_no_of_days = product.PromoNoOfDays;
		this.pack_name = product.IsPack ? product.PackName : null;
		this.price_list = product.PriceList;
		this.item_description = product.ItemDescription;
		this.category_ship_type_id = product.CategoryShipTypeId;
		this.category_ship_type_name = product.CategoryShipTypeName;
	}
}



// WEBPACK FOOTER //
// ./src/api/models/PackItem.js